module.exports = __webpack_public_path__ + "img/legiio.27f4807c.png";